
import { SpecialEvent } from '../../types/specialEvent';
import { skills } from '../skills';

export const techBreakthroughEvent: SpecialEvent = {
  id: 'tech-breakthrough',
  title: 'Mining Technology Breakthrough',
  description: 'A new mining technology has emerged that could revolutionize the industry. How will you respond?',
  type: 'technology',
  triggerYears: [3, 6, 9, 15], // Tech breakthroughs can happen periodically
  options: [
    {
      text: 'Be an early adopter',
      outcome: 'You invest heavily in the new technology, accepting the risks of being first.',
      roleSpecificOutcome: [
        {
          roleId: 'engineer',
          outcome: 'Your engineering background helps you identify key optimizations for the new technology, giving you an edge over other early adopters.',
          kpiEffects: {
            efficiency: 8,
            uptime: 2
          },
          experienceGain: 40
        },
        {
          roleId: 'technician',
          outcome: 'Your technical skills allow you to implement the new technology with minimal issues.',
          kpiEffects: {
            efficiency: 6,
            uptime: 3
          },
          experienceGain: 35
        }
      ],
      skillSpecificOutcome: [
        {
          skillId: 'advanced-diagnostics',
          outcome: 'Your advanced diagnostics skills help you quickly troubleshoot initial problems with the new technology.',
          kpiEffects: {
            uptime: 5,
            efficiency: 3
          },
          experienceGain: 30
        }
      ],
      kpiEffects: {
        efficiency: 5,
        uptime: -3,
        profitMargin: -5
      },
      experienceGain: 30
    },
    {
      text: 'Wait and evaluate',
      outcome: 'You observe the market and adopt only once the technology has proven itself.',
      roleSpecificOutcome: [
        {
          roleId: 'operations',
          outcome: 'Your operational focus allows for a seamless integration when you do adopt the technology.',
          kpiEffects: {
            uptime: 3,
            efficiency: 2
          },
          experienceGain: 25
        }
      ],
      skillSpecificOutcome: [
        {
          skillId: 'market-analysis',
          outcome: 'Your market analysis skills help you time the adoption perfectly, minimizing costs.',
          kpiEffects: {
            profitMargin: 4,
            efficiency: 2
          },
          experienceGain: 20
        }
      ],
      kpiEffects: {
        efficiency: 2,
        uptime: 1,
        profitMargin: 1
      },
      experienceGain: 15
    },
    {
      text: 'Develop your own solution',
      outcome: 'You invest in R&D to develop a proprietary alternative to the new technology.',
      roleSpecificOutcome: [
        {
          roleId: 'engineer',
          outcome: 'Your engineering expertise results in a solution that outperforms the market standard.',
          kpiEffects: {
            efficiency: 10,
            profitMargin: 5
          },
          experienceGain: 50
        }
      ],
      skillSpecificOutcome: [
        {
          skillId: 'custom-firmware-development',
          outcome: 'Your custom firmware development skills allow you to create an exceptionally optimized solution.',
          kpiEffects: {
            efficiency: 12,
            energyCost: -0.005
          },
          experienceGain: 45
        }
      ],
      kpiEffects: {
        efficiency: 0,
        profitMargin: -8,
        uptime: -2
      },
      experienceGain: 35,
      skillUnlock: skills.find(s => s.id === 'custom-firmware-development')
    }
  ]
};
